<template>
  <div class="detail">
    <div class="title">{{ detail?.contentTitle || detail?.newsTitle }}</div>
    <div class="subTit" v-if="!noSubTitle">
      <div class="fromTime">
        <div v-if="detail?.deptName">发布来源：<span>{{ detail?.deptName }} </span></div>
        <div v-if="detail?.createTime">发布时间：{{ detail?.createTime }}</div>
      </div>
      <change-font-size dom-id="bodyContent" />
    </div>
    <div class="images" v-if="detail?.newsFormat === 2 || detail?.contentFormat === 2">
      <img v-for="(item, index) in imagesArr" :key="index" :src="item" />
    </div>
    <video v-if="detail?.newsFormat === 3 || detail?.contentFormat === 3" :src="getVideoUrl()"
      controls></video>
    <show-html-content :contentHTML="detail?.newsContent || detail?.content || ''" />
  </div>
</template>

<script setup>
  import ChangeFontSize from "./changeFontSize.vue";
  import ShowHtmlContent from "./showHtmlContent.vue";

  const FILE_HOST = import.meta.env.VITE_FILE_HOST
  const props = defineProps({
    detail: {
      required: true
    },
    noSubTitle: {
      default: false
    }
  })
  let imagesArr = []
  if (props.detail?.newsFormat === 2 || props.detail?.contentFormat === 2) {
    let images = props.detail.newsTitleCover || props.detail.contentTitleCover
    images = images.split(",")
    images.forEach(item => {
      if (item) imagesArr.push(FILE_HOST + item)
    })
  }
  function getVideoUrl() {
    if (props.detail?.newsVideo) {
      return FILE_HOST + props.detail?.newsVideo
    }
    if (props.detail?.contentVideo) {
      return FILE_HOST + props.detail?.contentVideo
    }
  }
</script>

<style scoped lang="scss">
  .detail {
    padding: 64px 0 133px;

    >.title   {
      font-size: 24px;
      font-weight: 600;
      color: var(--title-text-color);
      text-align: center;
    }

    >.subTit {
      width: 100%;
      margin: 30px auto 0;
      text-align: center;
       display: flex;
       align-items: center;
       justify-content: center;

      >.fromTime {
        font-size: 16px;
        //width: 550px;
        margin-right: 80px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          //width: 230px;
          //white-space: nowrap;
          //overflow: hidden;
          //text-overflow: ellipsis;
          margin-right: 10px;
        }
      }
    }

    >video {
      width: 900px;
      height: 450px;
      margin: 75px auto 90px;
      display: block;
    }

    >.images {
      text-align: center;
      margin: 75px auto 90px;
      img {
        max-width: 100%;
      }
    }
  }
</style>